import type { FormatoDownload, StatusDoPacote } from '../types/baixarProcesso.types';
import { LIMITE_POR_PARTE_MB } from './arquivosDoPacote';

export type SituacaoPasso = 'concluido' | 'emAndamento' | 'aguardando';

interface PassoGeracao {
  titulo: string;
  situacao: SituacaoPasso;
}

/**
 * Os passos saem do STATUS que o servidor devolve, não de um relógio: a barra de porcentagem e a
 * contagem de anexos de antes eram inventadas e andavam sozinhas. `null` é o pedido ainda sem
 * resposta. Textos escritos sem mock — gancho para a designer aprovar ou trocar.
 */
export function passosDaGeracao(
  formato: FormatoDownload,
  status: StatusDoPacote | null,
): PassoGeracao[] {
  const indiceAtual = status === null ? 0 : status === 'PENDENTE' ? 1 : 2;
  const titulos = [
    'Registrando o pedido',
    'Aguardando a vez na fila',
    formato === 'partes'
      ? `Montando o PDF e dividindo em partes de até ${LIMITE_POR_PARTE_MB} MB`
      : 'Montando o PDF',
  ];

  return titulos.map((titulo, indice) => ({
    titulo,
    situacao:
      indice < indiceAtual ? 'concluido' : indice === indiceAtual ? 'emAndamento' : 'aguardando',
  }));
}

/**
 * O estado em palavras, para não depender de cor nem de ícone.
 *
 * @example rotuloDoStatus('PENDENTE') // 'Na fila'
 */
export function rotuloDoStatus(status: StatusDoPacote | null): string {
  if (status === 'PENDENTE') return 'Na fila';
  if (status === 'GERANDO') return 'Processando';
  if (status === 'PRONTO') return 'Pronto';
  if (status === 'FALHOU') return 'Erro';
  return 'Enviando o pedido';
}
